import React, { useContext, useEffect, useRef, useState } from 'react';
import {fabric} from "fabric";
import { Card, Empty, List, Tag, Typography, Badge, Tooltip, Button } from 'antd';
import { LoadingContext } from '../../composants/loadingContext';
import axiosInstance from '../../configurations/axiosInstance/AxiosInstance';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faClock, faTrophy, faDownload, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { useTitle } from '../../configurations/utils/Utils';
import Loader from '../../composants/loader/Loader';
import { formatAuthor, formatTitle } from '../../composants/utils/utils';

const { Title, Text } = Typography;

const Certification = () => {
    const [certifications, setCertifications] = useState([]);
    const { loading, setLoading } = useContext(LoadingContext);
    const { accessToken, user } = useSelector(state => state.authUser);
    const canvasRef = useRef(null);
    const [certificat, setCertificat] = useState(null);
    useTitle("Mes Certifications");

    const viewImage = (item) => {
        const canvas = new fabric.Canvas(canvasRef.current, {
            width: 841,
            height: 595,
            backgroundColor: '#f0f0f0',
            selection: true,
        });

        console.log("before", canvas.getObjects());  
        canvas.loadFromJSON(certificat.contenu, () => {
            // Mettre à jour les textes
            canvas.getObjects().forEach((obj) => {
                if (obj.type === 'textbox') {
                    switch (obj.id) {
                        case 'textUserName':
                            obj.set({
                                'text': 'Mm/Ms/M. '+(item.utilisateur.prenom + formatAuthor(item.utilisateur.nom, 4)) || '',
                                'underline': true,
                                'textDecoration': 'underline'
                            });
                            break;
                        case 'textUserNameDroite':
                            obj.set('text', "Administrator" || '');
                            break;
                        case 'textUserNameGauche':
                            obj.set('text', "Administrator" || '');
                            break;
                    }
                }
            });
            
            canvas.renderAll();
            

        console.log("after", canvas.getObjects()); 
            if (canvas) {
                const dataURL = canvas.toDataURL({ format: 'png' });
                const link = document.createElement('a');
                link.href = dataURL;
                link.download = 'certification.png';
                link.click();
            }
        });
    };
    const fetchCertificat = () => {
        axiosInstance(accessToken)
            .get(`api/certificate/to_use`)
            .then(response => {
                setCertificat(response.data);
            })
            .catch(error => {
                console.error("Erreur lors du chargement des certifications:", error);
                setLoading(false);
            });
    };

    const fetchCertifications = () => {
        setLoading(true);
        axiosInstance(accessToken)
            .get(`api/sondage/result`)
            .then(response => {
                setCertifications(response.data);
                setLoading(false);
                fetchCertificat();
            })
            .catch(error => {
                console.error("Erreur lors du chargement des certifications:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchCertifications();
    }, []);

    const jour = (dateString)=>{
        const date = formatDate(dateString);
        return date.split(' à ')[0];
    }

    const heure = (dateString)=>{
        const date = formatDate(dateString);
        return date.split(' à ')[1];
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };
        const optionsTime = { hour: '2-digit', minute: '2-digit' };
        
        const formattedDate = date.toLocaleDateString('fr-FR', optionsDate);
        const formattedTime = date.toLocaleTimeString('fr-FR', optionsTime);
        
        return `${formattedDate} à ${formattedTime}`;
    };

    if (loading) return <Loader />;

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="text-center mb-12">
                <Title level={1} className="text-4xl font-bold mb-4">
                    <FontAwesomeIcon icon={faTrophy} className="text-yellow-500 mr-3" />
                    Mes Certifications
                </Title>
                <Text className="text-gray-600 text-lg">
                    Retrouvez ici toutes vos certifications obtenues
                </Text>
            </div>

            {certifications.length === 0 ? (
                <Empty
                    description={
                        <span className="text-gray-500">
                            Vous n'avez pas encore obtenu de certification. Continuez à apprendre !
                        </span>
                    }
                    className="bg-white p-8 rounded-lg shadow-sm"
                />
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {certifications.map((certification) => (
                        <Card
                            key={certification.id}
                            className="hover:shadow-lg transition-shadow duration-300 border-0 rounded-xl overflow-hidden"
                            cover={
                                <div className="h-48 bg-gradient-to-r from-blue-500 to-purple-600 p-6 flex items-center justify-center">
                                    <FontAwesomeIcon icon={faMedal} className="text-6xl text-white" /> 
                                    <h1 className="text-5xl text-white" title={certification.formation.libelle}>{formatTitle(certification.formation.libelle, 10)}</h1>
                                </div>
                            }
                        >
                            <Badge.Ribbon 
                                text={(certification.score / certification.scoreTotal) *100 >= 80 ? "Excellence" : "Réussite"} 
                                color={(certification.score / certification.scoreTotal) *100 >= 80 ? "gold" : "blue"}
                            >
                                <div className="p-4">
                                    <Title title={certification.formation.libelle} level={4} className="mb-3 text-lg font-semibold">
                                        {formatTitle(certification.formation.libelle, 10)}
                                    </Title>
                                    
                                    <div className="space-y-3">
                                        <div className="flex items-center text-gray-600">
                                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
                                            <Text>{jour(certification.dateTime)}</Text>
                                        </div>
                                        
                                        <div className="flex items-center text-gray-600">
                                            <FontAwesomeIcon icon={faClock} className="mr-2" />
                                            <Text>{heure(certification.dateTime)} heures de formation</Text>
                                        </div>

                                        <Tag color="green" className="mt-2">
                                            Score: {certification.score}%
                                        </Tag>
                                    </div>

                                    <div className="mt-4 flex justify-end">
                                        <Tooltip title="Télécharger le certificat">
                                            <Button onClick={()=>{viewImage(certification)}} className={`flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors`}>
                                                <FontAwesomeIcon icon={faDownload} className="mr-2" />
                                                {loading ? 'Génération...' : 'Télécharger'}
                                            </Button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </Badge.Ribbon>
                        </Card>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Certification;